import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient) {}

  createContact(payload): Observable<any> {
    payload['client'] = 'babafurniture.in';
    return this.http.post(
      `${environment.FIREBASE_SERVER_URL}/contactUs`,
      payload
    );
  }
}
